/* Associations export orders search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';
import { OrderStatuses } from '../order/orderpricing';

export interface ISearchFiltersAssociationExportOrdersState {
    coordinator: string;
    manager: string;
    regionId: any;
    statusId: any;
    fromBidDate: any;
    toBidDate: any;
}

// const defaultFromBidDateRangeValue = DateRanges.DateRangeOptionValues.LAST_SIX_MONTHS;
const defaultFromBidDateRangeValue = DateRanges.DateRangeOptionValues.SINCE_TWO_THOUSAND;

export const initialState: ISearchFiltersAssociationExportOrdersState = {
    coordinator: '',
    manager: '',
    regionId: -1,
    statusId: OrderStatuses.JOB_SENT_OR_WON_STATUSES,
    fromBidDate: DateRanges.getStartDate(defaultFromBidDateRangeValue),
    toBidDate: '',
};

export function searchFiltersAssociationExportOrdersReducer(state: ISearchFiltersAssociationExportOrdersState = initialState, action: any): ISearchFiltersAssociationExportOrdersState {
    switch (action.type) {
        case Actions.ASSOCIATION_EXPORT_ORDERS_FROM_BID_DATE:
            return _.merge({}, state, { fromBidDate: action.value });
        case Actions.ASSOCIATION_EXPORT_ORDERS_TO_BID_DATE:
            return _.merge({}, state, { toBidDate: action.value });
        case Actions.ASSOCIATION_EXPORT_ORDERS_FILTER_STATUS:
            return _.merge({}, state, { statusId: action.statusId });
        case Actions.ASSOCIATION_EXPORT_ORDERS_FILTER_REGION:
            return _.merge({}, state, { regionId: action.regionId });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersAssociationExportOrdersReducer.tsx